function AmazonPayoutDetailCtrl($state, $auth, $stateParams, BulkCostService, AppSettings, CommonService, $rootScope, AmazonPayoutService) {
    'ngInject';
    const vm = this;
    vm.payoutDetails = [];
    vm.pageNumber = !$stateParams.pageNumber ? 1 : $stateParams.pageNumber;
    vm.size = !$stateParams.size ? 50 : $stateParams.size;
    vm.sortBy = !$stateParams.sortBy ? '' : $stateParams.sortBy;
    vm.searchParams = {
        transactionType: (!$stateParams.transactionType) ? '' : $stateParams.transactionType,
        amountType: (!$stateParams.amountType) ? '' : $stateParams.amountType,
        marketplaceName: (!$stateParams.marketplaceName) ? '' : $stateParams.marketplaceName,
        amountDescription: (!$stateParams.amountDescription) ? '' : $stateParams.amountDescription

    }
    vm.sortFlag = false;

    vm.init = function() {
        vm.url = `/organizations/${$stateParams.orgId}/amazon_payout_invoices/${$stateParams.invoiceId}/amazon_payout_details.json?page=${vm.pageNumber}&size=${vm.size}&sort=${vm.sortBy}&by_transaction_type=${vm.searchParams.transactionType}&by_marketplace_name=${vm.searchParams.marketplaceName}&by_amount_type=${vm.searchParams.amountType}&by_amount_description=${vm.searchParams.amountDescription}`;
        vm.dataLoading = true;
        AmazonPayoutService.getPayoutInvoiceDetails($stateParams.orgId, vm.url, function(response) {
            vm.dataLoading = false;
            if (response.status == 200) {
                vm.response = response.data;
                vm.currentPage = !vm.response.pagination ? 1 : vm.response.pagination.current_page;
                vm.totalPages = !vm.response.pagination ? 1 : vm.response.pagination.total_page;
                vm.invoiceDetails = response.data.amazon_payout_details;
                vm.invoice = response.data.invoice;
            }
        });

    };

    vm.search = function() {
        $state.go('user.organization.dashboard.amazonPayout.details', { pageNumber: vm.pageNumber, size: vm.size, transactionType: vm.searchParams.transactionType, marketplaceName: vm.searchParams.marketplaceName, amountType: vm.searchParams.amountType, amountDescription: vm.searchParams.amountDescription })
    };

    vm.sortFlag = function(param) {
        var currentSort = $stateParams.sortBy;
        if (currentSort && currentSort.endsWith(param)) {
            if (!currentSort.includes('-')) {
                return false;
            }
        }
        return true;
    };

    vm.sort = function(param) {
        var currentSort = $stateParams.sortBy;
        if (currentSort && currentSort.endsWith(param)) {
            if (!currentSort.includes('-')) {
                param = '-' + param;
            }
        }
        $state.go('user.organization.dashboard.amazonPayout.details', { sortBy: param });
    };

    vm.paginate = function(param) {
        vm.url = vm.response.links[param];
        if (vm.url) {
            var arr = vm.url.split('?');
            vm.pageNumber = CommonService.getParameterByName('page', vm.url);
            vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
            $state.go('user.organization.dashboard.amazonPayout.details', { pageNumber: vm.pageNumber, size: vm.size });
        }
    };

    vm.rowChange = function(param, pageSize) {
        vm.url = vm.response.links[param];
        var arr = vm.url.split('?');
        vm.pageNumber = 1;
        vm.size = pageSize;
        vm.url = arr[0] + '.json?page=' + vm.pageNumber + '&size=' + vm.size;
        $state.go('user.organization.dashboard.amazonPayout.details', { pageNumber: vm.pageNumber, size: vm.size });
    };



}

export default {
    name: 'AmazonPayoutDetailCtrl',
    fn: AmazonPayoutDetailCtrl
}